export default __webpack_public_path__ + "static/media/un.160cf220.svg";